<template>
<div class="layout">
  <div class="layout__header">
    <div class="layout__title">
      <h3>Autorización de documentos</h3>
    </div>
    <div class="layout__controls">
      <div class="form-inline">
        <button @click="enviarComprobantes" class="btn-bus200" type="button"><i class="fa fa-send"></i><span>Enviar comprobantes</span></button>
        <button @click="consultar" class="btn-info btn--bigger" type="button"><i class="fa fa-search"></i> <span>Consultar</span></button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card__content">
      <div class="row">
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <label for="todosComprobantes">
              <input v-model="form.todos_comprobantes" type="checkbox" id="todosComprobantes"> <span>Consultar todos los tipos de comprobante</span>
            </label>
          </div>
        </div>
        <div v-show="!form.todos_comprobantes" class="col-xs-12 col-md-4">
          <div :class="{'select2--disabled' : form.todos_comprobantes}"
            class="form-field select2">
            <div class="select2-field select2-field--stretch">
              <v-select v-model="selectedTipoComprobante" :options="tiposComprobante" label="descripcion" id="tipoComprobante" placeholder="Seleccione..."></v-select>
              <label class="label-nowrap" for="tipoComprobante">Tipo de comprobante</label>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-4">
          <div class="form-field">
            <label for="enCola">
              <input @change="consultar" v-model="form.en_cola" type="checkbox" id="enCola"> <span>Mostrar los documentos en cola</span>
            </label>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th v-show="!form.en_cola">
                <label v-show="comprobantes.length > 0" tooltip="Seleccionar todo" tooltip-position="right" for="todos">
                  <input v-model="todos" @change="seleccionarTodos" type="checkbox" id="todos"> <span></span>
                </label>
              </th>
              <th>Tipo de documento</th>
              <th># Documento</th>
              <th>Fecha de emisión</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Error SRI</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="comprobantes.length === 0">
              <td :colspan="!form.en_cola?8:7">
                <strong>No se encontró registros.</strong>
              </td>
            </tr>
            <tr :class="{
              'tr--canceled' : comprobante.tiene_error === 'S',
              'tr--pending' : comprobante.fecha_futura === 'S'
            }" v-for="(comprobante, index) in comprobantes" :key="index">
              <td v-show="!form.en_cola">
                <label :for="'comprobante' + index">
                  <input type="checkbox" :id="'comprobante' + index" v-model="comprobantesSeleccionados" :value="comprobante.id_comprobante"><span></span>
                </label>
              </td>
              <td>
                {{ comprobante.tipo_comprobante.descripcion }}
              </td>
              <td>{{ comprobante.numero_documento }}</td>
              <td>{{ comprobante.fecha_emision_comprobante }}</td>
              <td>{{ comprobante.cliente.nombre }}</td>
              <td>{{ comprobante.valor_total !== null?'$' + parseFloat(comprobante.valor_total).toLocaleString(locale):'' }}</td>
              <td>
                {{ comprobante.tiene_error === 'S'?'Sí':'No' }}
              </td>
              <td class="table-actions">
                <button class="btn-info btn--text" tooltip="Visualizar" type="button" @click="visualizarComprobante(comprobante)"><i class="fa fa-eye"></i></button>
                <button @click="mostrarEventosComprobante(comprobante.id_comprobante)" type="button" class="btn-secondary btn--text" tooltip="Logs"><i class="fa fa-file-o"></i></button>
                <button @click="reenviar(index)" v-show="comprobante.en_procesamiento === 'S' && comprobante.pendiente_envio === 'N'" type="button" class="btn-warning btn--text"><i class="fa fa-share"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <modal name="eventos" width="70%" height="auto" scrollable>
    <eventos-comprobante :idComprobante="selectedIdComprobante"></eventos-comprobante>
  </modal>
</div>
</template>

<script>
export default {
    data : function () {
        return {
            comprobantes : [],
            tiposComprobante : [],
            form : {
                id_tipo_comprobante : '',
                todos_comprobantes : true,
                en_cola : false
            },
            selectedTipoComprobante : null,
            url : url,
            comprobantesSeleccionados : [],
            todos : false,
            selectedIdComprobante : '',
            locale : locale
        };
    },
    watch : {
        selectedTipoComprobante : function (value) {
            if (value !== undefined && value !== null)
            {
                this.form.id_tipo_comprobante = value.id_tipo_comprobante;
                this.consultar();
            }
            else 
                this.form.id_tipo_comprobante = '';
        },
        'form.todos_comprobantes' : function (value) {
            if (value)
            {
                this.selectedTipoComprobante = null;
                this.consultar();
            }
        }
    },
    methods : {
        reenviar : function (index) {
          let comp = this.comprobantes[index];
          if (comp !== undefined && comp !== null) {
            let that = this;
            swal({
                  title: '¿Deseas re-enviar este comprobante?',
                  text: "Esta acción requiere de confirmación.",
                  type: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Re-enviar',
                  cancelButtonText : 'No'
              }).then((result) => {
                  if (result.value)
                    {
                      axios.post(url + '/comprobantes/reenviar/' + comp.id_comprobante).then(function (response) {
                        that.comprobantes.splice(index, 1);
                        swal('El comprobante ha sido re-enviado.', 'Realizado', 'success');
                      }).catch(function () {
                        swal('Hubo un error, intente nuevamente.', 'Aviso', 'warning');
                      });
                    }                
              });
          }
        },
        visualizarComprobante : function (comprobante) {
            window.open(this.url + '/comprobantes?tipo_comprobante=' + comprobante.id_tipo_comprobante + '&id_comprobante=' + comprobante.id_comprobante, '_blank');
        },
        consultar : function () {
            let that = this;
            axios.get(this.url + '/autorizacion-documentos/documentos', {
                params : this.form
            }).then(function (response) {
                that.comprobantes = response.data;
            });
        },
        cargarDatos : function () {
            let that = this;
            axios.get(this.url + '/autorizacion-documentos/datos').then(function (response) {
                that.tiposComprobante = response.data.tiposComprobante;
                that.consultar();
            });
        },
        seleccionarTodos : function () {
            if (this.todos)
                for (let i = 0; i < this.comprobantes.length; i++)
                    this.comprobantesSeleccionados.push(this.comprobantes[i].id_comprobante);
            else 
                this.comprobantesSeleccionados = [];
        },
        mostrarEventosComprobante : function (idComprobante) {
            window.open(this.url + '/comprobantes/' + idComprobante + '/logs', '_blank');
        },
        enviarComprobantes : function () {
            if (this.comprobantesSeleccionados.length > 0) {
                swal({
                    title: '¿Deseas autorizar los comprobantes seleccionados?',
                    text: "Se enviarán los comprobantes.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText : 'Autorizar',
                    cancelButtonText : 'Cancelar'
                    }).then((result) => {
                        if (result.value)
                        {
                            let that = this;
                            axios.post(this.url + '/autorizacion-documentos', {
                                comprobantes : this.comprobantesSeleccionados
                            }).then(function (response) {
                                swal('Se ha enviado un total de: ' + response.data.comprobantesEnviados + ' comprobante(s).', 'Mensaje', 'success');
                                that.comprobantesSeleccionados = [];
                                that.consultar();
                            }).catch(function (error) {
                                if (error !== undefined && error !== null) {
                                    let response = error.response;
                                    if (response !== undefined && response !== null) {
                                        let status = response.status;
                                        if (status === 422) 
                                            swal('Hubo un error de validación.', 'Error', 'error');
                                        else 
                                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                                    }
                                }
                            });
                        }
                });
            }
            else 
                swal('No ha seleccionado comprobante alguno.', 'Mensaje', 'warning');
        }
    },
    mounted : function () {
        this.cargarDatos();   
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Autorizacion.vue